import React, { Component } from 'react';
import PropTypes from 'prop-types';

class FiveStarLikert extends Component {
    static propTypes = {
        handleClick: PropTypes.func,
        starCount: PropTypes.number,
        score: PropTypes.number,
        idKey: PropTypes.string
    };

    constructor(props) {
        super(props);
        this.state = {
            hoverScore: 0,
            starSize: window.innerWidth < 481 ? '3' : '4'
        };
    }

    handleResize = () =>
        this.setState({
            starSize: window.innerWidth < 481 ? '3' : '4'
        });

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    renderStars = (starCount) => {
        const { handleClick, idKey, score = 0 } = this.props;
        const { hoverScore, starSize } = this.state;
        let source;
        const renderedStars = [];
        const starScore = Math.max(hoverScore, score);
        for (let i = 0, length = starCount; i < length; i += 1) {
            if (i < starScore) {
                source = (
                    <div
                        key={`likert-star-${i}`}
                        className={'likert-star'}
                        onClick={() => handleClick(idKey, i + 1)}
                        onMouseLeave={() => {
                            this.setState({ hoverScore: i });
                        }}
                    >
                        <i className={`fas fa-star fa-${starSize}x`} style={{ color: '#FFE600', marginTop: 5 }} />
                    </div>
                );
            } else {
                source = (
                    <div
                        key={`likert-star-${i}`}
                        className={'likert-star'}
                        onClick={() => handleClick(idKey, i + 1)}
                        onMouseEnter={() => this.setState({ hoverScore: i + 1 })}
                    >
                        <i className={`fal fa-star fa-${starSize}x`} style={{ color: '#CCC', marginTop: 5 }} />
                    </div>
                );
            }

            renderedStars.push(source);
        }

        return renderedStars;
    };

    render() {
        const { starCount = 5 } = this.props;

        return (
            <div className={'likert-star-row mx-auto mx-md-0'} onMouseLeave={() => this.setState({ hoverScore: 0 })}>
                {this.renderStars(starCount)}
            </div>
        );
    }
}

export default FiveStarLikert;
